import React from "react";
import moment from "moment-mini";
import { compose } from "redux";

import config from "../../../../../config";
import withAddAlert from "../../../../../hocs/withAddAlert";
import withTranslations from "../../../../../hocs/withTranslations";
import withUserData from "../../../../../hocs/withUserData";
import Price from "../../../../../common/Price";
import { canAccessPaymentInvoices } from "../../../../../lib/payment/canAccessPaymentInvoices";
import { INVOICE_REQUEST_STATUS } from "../../../../../lib/payment/invoiceRequestStatus";
import { isPaymentWithinInvoiceGenerationWindow } from "../../../../../lib/payment/isPaymentWithinInvoiceGenerationWindow";
import { getOfferDays } from "../../../../../lib/Plans";
import { showModal } from "../../../../../lib/react-redux-modal-provider";
import ContentSection from "../../../common/ContentSection";
import Loader from "../../../common/Loader";
import SquaberTable from "../../../common/SquaberTable";
import InvoiceIcon from "../../../../components/landingPage/components/LandingTypography/assets/invoice_icon.svg";
import "../styles/default.scss";

const renderInvoiceCell = ({ item, translate, userData, addErrorAlert }) => {
  if (!config.invoicesEnabled) {
    return "";
  }

  const invoiceRequestStatus = item?.invoice_request_status;

  if (invoiceRequestStatus === INVOICE_REQUEST_STATUS.SUCCESS) {
    return "";
  }

  if (!isPaymentWithinInvoiceGenerationWindow(item?.datetime_utc)) {
    return "";
  }

  const handleGenerateInvoice = () => {
    if (!canAccessPaymentInvoices(userData)) {
      addErrorAlert({
        title: "payment_create_invoice_error_email_not_verified"
      });
      return;
    }

    showModal("GenerateInvoiceModal", { paymentId: item.id });
  };

  const isPending =
    invoiceRequestStatus === INVOICE_REQUEST_STATUS.PENDING;
  const isError = invoiceRequestStatus === INVOICE_REQUEST_STATUS.ERROR;

  return (
    <div className={"transaction-history-box__invoice"}>
      <img
        className={"transaction-history-box__invoice__icon"}
        src={InvoiceIcon}
        alt={translate("Invoice icon")}
      />
      {isPending ? (
        <span className="transaction-history-box__invoice__status">
          {translate("transaction_history_invoice_request_pending")}
        </span>
      ) : isError ? (
        <span className="transaction-history-box__invoice__status">
          {translate("transaction_history_invoice_request_error")}
        </span>
      ) : null}
      {!isPending ? (
        <button
          type="button"
          className="transaction-history-box__invoice__button"
          onClick={handleGenerateInvoice}
        >
          {translate("transaction_history_generate_invoice")}
        </button>
      ) : null}
    </div>
  );
};

const TransactionHistoryBox = ({
  translate,
  transactionHistoryData,
  userData,
  addErrorAlert
}) => {
  return (
    <ContentSection>
      <h2 className="big-heading">{translate("Transactions history")}</h2>
      {transactionHistoryData.loading ? (
        <Loader small />
      ) : transactionHistoryData.data && transactionHistoryData.data.length ? (
        <SquaberTable
          withDistinctRows
          scrollsHorizontally
          widthArr={[120, 80, 85, 90, 150]}
          heading={[
            translate("Date"),
            translate("Plan name"),
            translate("Amount"),
            translate("Period"),
            ""
          ]}
          rows={transactionHistoryData.data.map(item => [
            moment(item.datetime_utc).format("DD.MM.YYYY[,] HH:mm"),
            item?.plan_name ?? "-",
            new Price({ value: item.amount, currency: item.currency }).render(),
            `${getOfferDays(item) ?? item.periods * 30} ${translate("days")}`,
            renderInvoiceCell({
              item,
              translate,
              userData,
              addErrorAlert
            })
          ])}
        />
      ) : (
        <p>{translate("Transactions history is empty")}</p>
      )}
    </ContentSection>
  );
};

export default compose(
  withTranslations,
  withUserData,
  withAddAlert
)(TransactionHistoryBox);
